import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Switch as BaseUISwitch } from '@base-ui/react/switch';
import { cn } from '../../../utils/utils';
/**
 * REVER's on/off toggle. Use it instead of MUI's `Switch`, which is deprecated in apps that consume the design system.
 * Controlled via `checked` + `onCheckedChange(checked)`; label it with `aria-label` or a `<label htmlFor>`.
 */
export const Switch = forwardRef(function Switch({ size = 'md', className, ...props }, ref) {
    return (_jsx(BaseUISwitch.Root, { ...props, ref: ref, className: cn('group relative inline-flex shrink-0 items-center rounded-full border border-solid border-neutral-200 bg-neutral-200 p-0.5 shadow-inner transition-colors cursor-pointer outline-none hover:bg-neutral-300 data-[checked]:border-primary-base data-[checked]:bg-primary-base data-[checked]:hover:bg-primary-hover focus-visible:ring-2 focus-visible:ring-primary-base/40 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60', {
            'h-5 w-9': size === 'sm',
            'h-6 w-11': size === 'md'
        }, className), children: _jsx(BaseUISwitch.Thumb, { className: cn('block rounded-full bg-white shadow-sm transition-transform', {
                'size-3.5 data-[checked]:translate-x-4': size === 'sm',
                'size-[1.125rem] data-[checked]:translate-x-5': size === 'md'
            }) }) }));
});
